import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const addNewTooltipText = 'Propose new asset for rent';

export const ERoles = {
	ao: 'AO',
	mno: 'MNO',
} as const;

export type TRoles = typeof ERoles[keyof typeof ERoles]

export const ERequestStatusesForAssetManagerAODecline = {
	pending: 'PENDING',
	inProgress: 'IN_PROGRESS',
	updated: 'UPDATED',
	allApproved: 'ALL_APPROVED',
	partlyApproved: 'PARTLY_APPROVED',
	allDisapproved: 'ALL_DISAPPROVED',
	sentForAcceptance: 'SENT_FOR_ACCEPTANCE',
	sentForRevision: 'SENT_FOR_REVISION',
} as const;

export type TRequestStatusesForAssetManagerAODecline =
	TValueOfStringRecord<typeof ERequestStatusesForAssetManagerAODecline>

export const ERequestStatusesForAOSignatoryDecline = {
	accepted: 'ACCEPTED',
	contract: 'CONTRACT',
} as const;

export type TRequestStatusesForAOSignatoryDecline = TValueOfStringRecord<typeof ERequestStatusesForAOSignatoryDecline>

export const ERequestStatusesForMNODecline = {
	pending: 'PENDING',
	inProgress: 'IN_PROGRESS',
	updated: 'UPDATED',
	allApproved: 'ALL_APPROVED',
	partlyApproved: 'PARTLY_APPROVED',
	allDisapproved: 'ALL_DISAPPROVED',
	accepted: 'ACCEPTED',
	contract: 'CONTRACT',
	sentForRevision: 'SENT_FOR_REVISION',
	sentForAcceptance: 'SENT_FOR_ACCEPTANCE',
} as const;

export type TRequestStatusesForMNODecline = TValueOfStringRecord<typeof ERequestStatusesForMNODecline>
